export const IMG = {
  hero: "https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  factory: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  welderHelmet: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  welderMetal: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  welderNight: "https://images.pexels.com/photos/28951817/pexels-photo-28951817.jpeg?auto=compress&cs=tinysrgb&w=1200",
  sparksFactory: "https://images.pexels.com/photos/4561617/pexels-photo-4561617.jpeg?auto=compress&cs=tinysrgb&w=1200",
  frameworkBlue: "https://images.pexels.com/photos/32239084/pexels-photo-32239084.jpeg?auto=compress&cs=tinysrgb&w=1200",
  laserCut: "https://images.unsplash.com/photo-1735494033576-9c882e80504c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  laserMachine: "https://images.unsplash.com/photo-1738162837451-2041c1418f54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  welderPiece: "https://images.pexels.com/photos/30790481/pexels-photo-30790481.jpeg?auto=compress&cs=tinysrgb&w=1200",
  // Foto reali fornite da MMC
  realScale: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/g7jzdsb0_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%282%29.jpeg",
  realTettoia: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/8v90d5am_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%284%29.jpeg",
  realScalaInterna: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/65pbwsed_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%285%29.jpeg",
  realRampa: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/m55a70uc_WhatsApp%20Image%202026-09-18%20at%2012.06.26.jpeg",
  realCapriate: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/dt6z395z_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%289%29.jpeg",
  realPasserella: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/rkxdyufr_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%287%29.jpeg",
  realScalaEsternaAmpia: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/wsfr4mbw_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%281%29.jpeg",
  realScalaLED: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/nowan4el_WhatsApp%20Image%202026-09-18%20at%2012.06.26%20%286%29.jpeg",
  realPasserellePilastri: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/zaogk5jp_WhatsApp%20Image%202026-09-18%20at%2014.12.27%20%282%29.jpeg",
  realScalaRinghieraPilastro: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/c41wvqnz_WhatsApp%20Image%202026-09-18%20at%2014.12.26%20%286%29.jpeg",
  realPilastriCopertura: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/vexl1zz0_WhatsApp%20Image%202026-09-18%20at%2014.12.26%20%283%29.jpeg",
  realPasserelleVista: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/0vjncm9f_WhatsApp%20Image%202026-09-18%20at%2014.12.26%20%282%29.jpeg",
  realPilastriPiastre: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/o8jcxs2u_WhatsApp%20Image%202026-09-18%20at%2014.12.26%20%281%29.jpeg",
  realScalaVetrata1: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/2d73bcda_WhatsApp%20Image%202026-09-18%20at%2014.17.11%20%281%29.jpeg",
  realScalaVetrata2: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/nj66ptk0_WhatsApp%20Image%202026-09-18%20at%2014.13.37%20%282%29.jpeg",
  realScalaGiorno: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/w9y4kbdp_WhatsApp%20Image%202026-09-18%20at%2014.15.56%20%281%29.jpeg",
  realTettoiaBianca: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/fzdqkrft_WhatsApp%20Image%202026-09-18%20at%2014.13.37.jpeg",
  realFacciata1: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/h4ofrbso_WhatsApp%20Image%202026-09-18%20at%2014.20.39.jpeg",
  realFacciata2: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/dsitpjlj_WhatsApp%20Image%202026-09-18%20at%2014.20.39%20%283%29.jpeg",
  realFacciataDettaglio: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/j9mfplal_WhatsApp%20Image%202026-09-18%20at%2014.20.40%20%281%29.jpeg",
  realSchermaturaDettaglio: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/j5e6sd4t_WhatsApp%20Image%202026-09-18%20at%2014.20.40%20%284%29.jpeg",
  realSchermatureMuro: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mmc-services/artifacts/54ivughw_WhatsApp%20Image%202026-09-18%20at%2014.20.40%20%285%29.jpeg",
};

export const COMPANY = {
  name: "MMC S.r.l.",
  brand: "Carpenteria MMC",
  sector: "Carpenteria Metallica",
  founded: 2010,
  claim: "Competenza, qualità e affidabilità al servizio dei nostri clienti",
  intro:
    "Offriamo soluzioni professionali e personalizzate, seguendo ogni progetto con attenzione, esperienza e assistenza dedicata.",
  phoneDisplay: "035 452 1262",
  phoneHref: "tel:+390354521262",
  whatsappHref: "https://wa.me/393351637652",
  emailDisplay: "info@mmcsrl.com",
  emailHref: "mailto:info@mmcsrl.com",
  pecDisplay: "mmcsrl@legalmail.it",
  pecHref: "mailto:mmcsrl@legalmail.it",
  addressDisplay: "Via Artigiani 9 — 24060 Piano Insediamenti Produttivi (BG)",
  mapEmbed:
    "https://maps.google.com/maps?q=Via%20Artigiani%209%2C%2024060%20Piano%20Insediamenti%20Produttivi%20BG&z=16&output=embed",
  google: { rating: "5,0", count: 4 },
  hours: [
    { d: "Lunedì – Venerdì", h: "7:00 – 17:00" },
    { d: "Sabato – Domenica", h: "Chiuso" },
  ],
  legal: {
    ragioneSociale: "MMC S.r.l.",
    sede: "Via Artigiani 9 — 24060 Piano Insediamenti Produttivi (BG)",
    piva: "03661020168",
    cf: "03661020168",
    rea: "BG - 397325",
  },
};

export const STORIA = [
  "Fondata nel 2010, MMC S.r.l. opera nel settore della carpenteria metallica, trasformando il metallo in soluzioni solide, funzionali e curate in ogni dettaglio. L'esperienza maturata negli anni, unita a una profonda passione per il mestiere, ci permette di affrontare ogni lavorazione con competenza, precisione e attenzione alle esigenze del cliente.",
  "Realizziamo parapetti, strutture metalliche, cancelli, corrimani, scale interne ed esterne ed elementi di interior design, oltre a progetti personalizzati sviluppati interamente su misura. Dalla progettazione alla realizzazione, seguiamo ogni fase con cura, con l'obiettivo di creare opere capaci di unire resistenza, sicurezza ed eleganza.",
  "Ogni progetto nasce dall'ascolto: studiamo gli spazi, interpretiamo le necessità tecniche ed estetiche e individuiamo la soluzione più adatta al contesto. Che si tratti di una struttura complessa, di un elemento architettonico o di un dettaglio d'arredo, lavoriamo per dare forma a realizzazioni uniche, pensate per integrarsi armoniosamente in ambienti residenziali, commerciali e professionali.",
  "La nostra filosofia si fonda sulla qualità delle lavorazioni, sulla cura delle finiture e sulla capacità di valorizzare un materiale versatile e senza tempo come il metallo. Per MMC S.r.l., ogni nuova commessa rappresenta l'opportunità di coniugare esperienza artigianale, affidabilità e ricerca estetica.",
  "Dal progetto alla posa, trasformiamo le idee in realizzazioni su misura, costruite per durare e pensate per distinguersi.",
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/lavori-realizzati", label: "Lavori" },
  { to: "/news", label: "News" },
  { to: "/contatti", label: "Contatti" },
];

export const SERVICES = [
  {
    id: "carpenteria-pesante",
    title: "Carpenteria pesante",
    img: IMG.realCapriate,
    short: "Strutture portanti, travi e telai per capannoni e opere industriali.",
    desc: "Progettiamo e realizziamo strutture portanti in acciaio: telai per capannoni, travi reticolari, impalcati e opere di grande impegno dimensionale. Seguiamo la commessa dalla lavorazione della materia prima al montaggio in cantiere, con controlli costanti su ogni fase.",
    benefits: [
      "Dimensionamenti su misura per ogni commessa",
      "Materiali certificati e tracciabili",
      "Montaggio e assistenza diretta in cantiere",
    ],
  },
  {
    id: "carpenteria-leggera",
    title: "Carpenteria leggera e metalliche",
    img: IMG.frameworkBlue,
    short: "Lavorazioni in lamiera e profilati: coperture, supporti, strutture di completamento.",
    desc: "La carpenteria leggera è il regno della precisione: infissi tecnici, coperture, controtelai, strutture di supporto e complementi in lamiera e profilati leggeri. Flessibilità massima su dimensioni, finiture e tempi di consegna.",
    benefits: [
      "Grande flessibilità dimensionale",
      "Finiture a scelta: zincatura, verniciatura, metallizzazione",
      "Tempi di lavorazione rapidi",
    ],
  },
  {
    id: "saldatura-certificata",
    title: "Saldatura certificata",
    img: IMG.welderHelmet,
    short: "Saldature TIG, MIG e MAG su acciaio al carbonio, inox e alluminio.",
    desc: "Il reparto saldatura è il cuore della nostra officina: procedure qualificate e saldatori esperti su acciaio al carbonio, inox e alluminio. Ogni giunto viene controllato perché la struttura duri nel tempo, senza sorprese.",
    benefits: [
      "Procedure e saldatori qualificati",
      "Controlli visivi e verifiche di qualità",
      "Qualità costante su serie e pezzi unici",
    ],
  },
  {
    id: "costruzioni-manutenzioni",
    title: "Costruzioni e manutenzioni industriali",
    img: IMG.welderMetal,
    short: "Realizzazione e manutenzione di strutture e impianti, anche con pronto intervento.",
    desc: "Accompagniamo le aziende industriali nel tempo: nuove costruzioni, modifiche e ampliamenti di strutture esistenti, manutenzioni programmate e pronto intervento per ripristinare rapidamente l'operatività.",
    benefits: [
      "Un solo interlocutore per tutto il ciclo",
      "Interventi programmati e di urgenza",
      "Massima attenzione alla sicurezza in cantiere",
    ],
  },
];

export const CATALOG = [
  {
    id: "scale-soppalchi",
    title: "Scale e soppalchi",
    items: [
      {
        id: "CAT-01",
        title: "Scala esterna zincata con castello e pianerottoli — vista d'insieme",
        img: IMG.realScalaEsternaAmpia,
      },
      {
        id: "CAT-02",
        title: "Scala esterna zincata con castello e pianerottoli",
        img: IMG.realScale,
      },
      {
        id: "CAT-03",
        title: "Scala interna in acciaio con corrimano inox",
        img: IMG.realScalaInterna,
      },
      {
        id: "CAT-04",
        title: "Dettaglio scala interna con corrimano e illuminazione LED",
        img: IMG.realScalaLED,
      },
      {
        id: "CAT-09",
        title: "Scala con ringhiera zincata a barotto e pilastro di sostegno",
        img: IMG.realScalaRinghieraPilastro,
      },
      {
        id: "CAT-14",
        title: "Scala interna con parapetti in ferro nero sotto copertura vetrata",
        img: IMG.realScalaVetrata1,
      },
      {
        id: "CAT-15",
        title: "Scala con parapetti in ferro nero sotto copertura vetrata — seconda vista",
        img: IMG.realScalaVetrata2,
      },
      {
        id: "CAT-16",
        title: "Scala sospesa a giorno con monoscivolo nero e pedate in legno",
        img: IMG.realScalaGiorno,
      },
    ],
  },
  {
    id: "rampe-ringhiere",
    title: "Rampe e ringhiere",
    items: [
      {
        id: "CAT-05",
        title: "Rampa di accesso zincata con doppio corrimano",
        img: IMG.realRampa,
      },
    ],
  },
  {
    id: "tettoie-coperture",
    title: "Tettoie e coperture",
    items: [
      {
        id: "CAT-06",
        title: "Tettoia in acciaio con soletta grigliata",
        img: IMG.realTettoia,
      },
      {
        id: "CAT-10",
        title: "Pilastri zincati di supporto alla copertura in legno",
        img: IMG.realPilastriCopertura,
      },
      {
        id: "CAT-17",
        title: "Tettoia in acciaio verniciata bianco con parapetti e rampa",
        img: IMG.realTettoiaBianca,
      },
    ],
  },
  {
    id: "strutture-capannoni",
    title: "Strutture e capannoni",
    items: [
      {
        id: "CAT-07",
        title: "Capannone industriale con capriate in acciaio",
        img: IMG.realCapriate,
      },
      {
        id: "CAT-08",
        title: "Passerella sopraelevata con aiuole pensili",
        img: IMG.realPasserella,
      },
      {
        id: "CAT-11",
        title: "Passerelle sopraelevate zincate su pilastri — dettaglio",
        img: IMG.realPasserellePilastri,
      },
      {
        id: "CAT-12",
        title: "Complesso di passerelle sopraelevate — vista di cantiere",
        img: IMG.realPasserelleVista,
      },
      {
        id: "CAT-13",
        title: "Pilastri in acciaio zincato con piastre di base",
        img: IMG.realPilastriPiastre,
      },
    ],
  },
  {
    id: "rivestimenti-schermature",
    title: "Rivestimenti e schermature",
    items: [
      {
        id: "CAT-18",
        title: "Facciata con pannelli metallici geometrici su telaio — vista d'insieme",
        img: IMG.realFacciata1,
      },
      {
        id: "CAT-19",
        title: "Facciata con pannelli metallici geometrici — schermatura finestroni",
        img: IMG.realFacciata2,
      },
      {
        id: "CAT-20",
        title: "Dettaglio pannelli in acciaio a cortine su supporti a V",
        img: IMG.realFacciataDettaglio,
      },
      {
        id: "CAT-21",
        title: "Pannelli schermanti in grigliato — dettaglio",
        img: IMG.realSchermaturaDettaglio,
      },
      {
        id: "CAT-22",
        title: "Schermature in grigliato su muro di contenimento — vista d'insieme",
        img: IMG.realSchermatureMuro,
      },
    ],
  },
];

export const NEWS = [
  {
    id: "news-01",
    cat: "Azienda",
    date: "[data]",
    title: "Il nuovo sito di MMC S.r.l. è online",
    excerpt:
      "Un vetro digitale sull'officina: servizi, catalogo dei lavori, e la possibilità di richiedere un preventivo in pochi minuti.",
  },
  {
    id: "news-02",
    cat: "Tecnica",
    date: "[data]",
    title: "Saldatura certificata: come garantiamo qualità e sicurezza",
    excerpt:
      "Procedure qualificate, controlli sui giunti e saldatori specializzati: ecco il nostro metodo per strutture che durano nel tempo.",
  },
  {
    id: "news-03",
    cat: "Servizio",
    date: "[data]",
    title: "Preventivi rapidi per strutture in acciaio",
    excerpt:
      "Disegno, materiale, quantità: cosa inviarci per ricevere in breve tempo una quotazione dettagliata e senza impegno.",
  },
];

export const VALUES = [
  { n: "01", title: "Competenza", desc: "Occhi esperti su ogni lavorazione: dal disegno tecnico al cantiere, ogni fase è seguita da chi il metallo lo conosce davvero." },
  { n: "02", title: "Qualità", desc: "Materiali certificati, macchine a controllo numerico e controlli continui: la qualità non è un controllo finale, è un metodo." },
  { n: "03", title: "Affidabilità", desc: "Tempi rispettati, preventivi chiari, un solo interlocutore: sappiamo che per il nostro cliente il conto alla rovescia è già iniziato." },
  { n: "04", title: "Assistenza", desc: "Non consegniamo e spariamo: restiamo al fianco del cliente anche dopo la consegna, per manutenzioni, modifiche e nuovi sviluppi." },
];

export const TEAM = [
  { role: "Direzione tecnica", desc: "Coordina progettazione e produzione e garantisce il metodo su ogni commessa." },
  { role: "Ufficio tecnico e progettazione", desc: "Trasforma disegni, file DXF e campioni fisici in programmi di lavorazione e schede di officina." },
  { role: "Reparto produzione e saldatura", desc: "Operatori specializzati su taglio, piega, calandra e saldatura certificata." },
  { role: "Logistica e cantiere", desc: "Movimentazione, consegne e montaggio: la struttura arriva dove deve arrivare, al momento giusto." },
  { role: "Amministrazione e commerciale", desc: "Preventivi, documentazione e certificazioni: tutto in ordine, dal primo contatto alla fattura." },
];

export const CERTS = [
  { code: "UNI EN 1090", desc: "Esecuzione di strutture in acciaio e alluminio" },
  { code: "ISO 9001", desc: "Sistema di gestione per la qualità" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Competenza",
    desc: "La competenza si costruisce ogni giorno, tra officina e cantiere. Ogni lavorazione passa da mani esperte che sanno leggere il metallo, il disegno e il problema del cliente prima ancora che sia troppo tardi.",
  },
  {
    n: "02",
    title: "Qualità",
    desc: "Non facciamo sconti sul controllo: materiali certificati, macchine a controllo numerico e verifiche su ogni fase. Una struttura in acciaio deve durare decenni, e la qualità si vede solo quando manca.",
  },
  {
    n: "03",
    title: "Affidabilità",
    desc: "Un preventivo chiaro, un tempo rispettato, un interlocutore unico. La fiducia dei nostri clienti è il nostro strumento di misura più importante, e si costruisce una consegna alla volta.",
  },
];

export const DEMO_NOTE =
  "* Articoli esemplificativi — in attesa delle prime notizie reali di MMC S.r.l.";
